<div class="table-controls">
    <div class="input-group flex-nowrap">
        <input type="text" placeholder="Search..." class="form-control" [(ngModel)]="searchQuery" (change)="submitSearch()" (keyup.enter)="submitSearch()">
        <button type="button" class="btn btn-outline-default" (click)="submitSearch()"><i class="bi bi-search"></i> </button>
    </div>
</div>

<div class="table-container">
    <table class="table table-striped">
        <thead>
            <tr>
                <th scope="col" *ngFor="let key of tableKeys">{{ key.title }}</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of filteredTableRows | slice: currentPage * displayCount: (currentPage * displayCount) + displayCount">
                <ng-container *ngFor="let key of tableKeys; let index = index">
                    <ng-container [ngSwitch]="key.columnType">
                        <!-- Date Column -->
                        <td *ngSwitchCase="'date'">{{ (row[key.key] | date: 'mediumDate') || "-" }}</td>
        
                        <!-- Status Column -->
                        <td *ngSwitchCase="'status'" class="table-status-col" >
                            <div class="rag-system-icon" [ngClass]="'rag-' + row[key.key]?.level.toString()"></div>
                            {{ row[key.key]?.message || "-" }}
                        </td>
        
                        <!-- Highlighted Column -->
                        <th *ngSwitchCase="'highlighted'"scope="row" class="table-highlighted-col">
                            <a (click)="selectRow(row)">
                                {{ row[key.key] || "-" }}
                            </a>
                        </th>

                        <!-- Boolean Column -->
                        <td *ngSwitchCase="'boolean'" class="table-boolean-col" >
                            <i *ngIf="row[key.key] == true" class="fa fa-check"></i>
                        </td>

                        <!-- Default Column -->
                        <td *ngSwitchDefault>{{ row[key.key] || "-" }}</td>
                    </ng-container>

                </ng-container>

                <!-- Action Column -->
                <td class="action-col">
                    <button *ngIf="isUpdateEnabled" class="btn btn-xs btn-outline-default" (click)="updateRow(row)" title="Update"><fa-icon [icon]="faEdit" size="s"></fa-icon></button>
                    <button *ngIf="isRowReplace" class="btn btn-xs btn-outline-default" (click)="replaceRow(row)" title="Repace"><fa-icon [icon]="faArrowCircleUp" size="s"></fa-icon></button>
                    <button *ngIf="isFileDownload && row.hasFile" class="btn btn-xs btn-outline-default" (click)="downloadRow(row)" title="Download"><fa-icon [icon]="faFileDownload" size="s"></fa-icon></button>
                    <button class="btn btn-xs btn-outline-danger" (click)="showConfirmModal(row)"><fa-icon [icon]="faTrash" size="s" title="Remove"></fa-icon></button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="table-pagination" *ngIf="totalPages > 1">
    <ul class="pagination">
        <li class="page-item">
            <button class="page-link" (click)="setCurrentPage(currentPage - 1)">Previous</button>
        </li>
        <li *ngFor="let page of pagination" class="page-item" [class.active]="page === currentPage">
            <button class="page-link" (click)="setCurrentPage(page)">{{ page + 1 }}</button>
        </li>
        <li class="page-item">
            <button class="page-link" (click)="setCurrentPage(currentPage + 1)">Next</button>
        </li>
    </ul>
</div>

<!-- Modal -->
<div class="modal fade" bsModal #confirmModal="bs-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">Confirm Delete</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="hideConfirmModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p *ngIf="rowToDelete">Are you sure you want to delete row: <strong>"{{ rowToDelete[tableKeys[0].key] || "-" }}"</strong></p>
            </div>
            <div class="modal-footer">
                <button class="btn btn-default" type="button" (click)="hideConfirmModal()">Cancel</button>
                <button class="btn btn-danger" type="button" (click)="[deleteRow(rowToDelete), hideConfirmModal()]">Delete</button>
            </div>
        </div>
    </div>
</div>